/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, TemplateRef } from '@angular/core';

import { ICellRendererParams } from 'ag-grid-community';

import { GridCellRendererComponent } from '../../grid-component.interfaces';

@Component({
  selector: 'gh-template-cell-renderer',
  template: '<ng-container *ngTemplateOutlet="templateRef; context: context"></ng-container>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridTemplateCellRendererComponent implements GridCellRendererComponent {
  templateRef: TemplateRef<any>;
  context: Hash<any> = {};

  constructor(private changeDetectorRef: ChangeDetectorRef) {

  }

  agInit(params: ICellRendererParams): void {
    this.templateRef = params['templateRef'];

    this.attachParameters(params);
  }

  refresh(params: any): boolean {
    this.attachParameters(params);
    this.changeDetectorRef.markForCheck();
    return true;
  }

  private attachParameters(params: any): void {
    this.context.$implicit = params.data;
    this.context.colDef = params.colDef;
    this.context.column = params.column;
    this.context.node = params.node;
  }
}
